import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function ClientDialog({
  open,
  onOpenChange,
  editing,
  form,
  setForm,
  folders,
  onSave,
}) {
  const update = (key, value) => setForm({ ...form, [key]: value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#171717] border-[#262626] text-white max-w-md"
        data-testid="client-dialog"
      >
        <DialogHeader>
          <DialogTitle
            className="font-bold tracking-tight uppercase"
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            {editing ? "MODIFICA CLIENTE" : "NUOVO CLIENTE"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Nome</Label>
              <Input
                value={form.first_name}
                onChange={(e) => update("first_name", e.target.value)}
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="client-first-name"
              />
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Cognome</Label>
              <Input
                value={form.last_name}
                onChange={(e) => update("last_name", e.target.value)}
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="client-last-name"
              />
            </div>
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Email</Label>
            <Input
              value={form.email}
              onChange={(e) => update("email", e.target.value)}
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="client-email"
            />
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Telefono</Label>
            <Input
              value={form.phone}
              onChange={(e) => update("phone", e.target.value)}
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="client-phone"
            />
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Cartella</Label>
            <Select
              value={form.folder_id || "none"}
              onValueChange={(v) =>
                update("folder_id", v === "none" ? "" : v)
              }
            >
              <SelectTrigger
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="client-folder-select"
              >
                <SelectValue placeholder="Nessuna cartella" />
              </SelectTrigger>
              <SelectContent className="bg-[#171717] border-[#262626]">
                <SelectItem value="none" className="text-white">
                  Nessuna cartella
                </SelectItem>
                {folders.map((f) => (
                  <SelectItem key={f.id} value={f.id} className="text-white">
                    {f.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A]"
            data-testid="client-cancel-button"
          >
            Annulla
          </Button>
          <Button
            onClick={onSave}
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="client-save-button"
          >
            {editing ? "Aggiorna" : "Crea"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
